import React, { useState, useEffect } from "react";
import SMModal from "../../elements/modals/SMModal";
import { ToastContainer, toast } from "react-toastify";
import axiosAPI from "../../utils/axios-api";
import { useParams } from "react-router-dom";
import swal from 'sweetalert2';

const API = process.env.REACT_APP_API;

export default function IsiKuesionerLiklert(props) {
  let { idKuesioner } = useParams();
  const [data, setdata] = useState(props.data ?? []);
  const [tipe, settipe] = useState(null);
  const [skala, setskala] = useState([]);
  const [totalSoal, settotalSoal] = useState(0);
  const [kuesioner_id, setKuesionerId] = useState(0);
  const [responden_id, setRespondenId] = useState(0);

  const [tab, settab] = useState(0);

  // answer
  const [answer, setanswer] = useState([]);
  const [fire, setfire] = useState(true);

  const [modalSave, setmodalSave] = useState(false);
  const [loadingSubmit, setloadingSubmit] = useState(0);

  useEffect(() => {
    setdata(props.data);
    settipe(props.tipe);
    setskala(props.skala);
    settotalSoal(props.total);
    setKuesionerId(props.kuesioner_id)
    setRespondenId(props.responden_id)
    
  }, []);

  const notify = () =>
    toast.error("Lengkapi jawaban anda", {
      position: "top-right",
      autoClose: 10000,
    });

  function onSave(params) {
    if (answer.length === totalSoal) {
      setmodalSave(!modalSave);
    } else {
      notify();
    }
  }

  function changeVal(params) {
    let { idx, val } = params;
    let ans = answer;
    ans[idx] = val;
    setanswer(ans);
    setfire(!fire);
  }

  function renderButton(params) {
    return (
      <div className="flex flex-row justify-between">
        {tipe !== 1 ? (
          <div className="flex flex-row gap-2">
            <button
              className={
                tab > 0
                  ? "px-4 py-2 bg-green-500 text-white rounded"
                  : "px-4 py-2 bg-gray-300 text-white rounded"
              }
              onClick={() => {
                if (tab > 0) {
                  settab(tab - 1);
                }
              }}
            >
              Prev
            </button>
            <button
              className={
                tab < data.length - 1
                  ? "px-4 py-2 bg-green-500 text-white rounded"
                  : "px-4 py-2 bg-gray-300 text-white rounded"
              }
              onClick={() => {
                if (tab < data.length - 1) {
                  settab(tab + 1);
                }
              }}
            >
              Next
            </button>
          </div>
        ) : null}

        <button
          onClick={() => onSave()}
          className="px-4 py-2 rounded bg-blue-500 text-white"
        >
          Submit
        </button>
      </div>
    );
  }

  function view1(params) {
    return (
      <div className="flex flex-col w-100 px-4">
        {typeof fire === "boolean" ? (
          <table className="mb-4 mt-4 w-full border border-gray-700">
            <tr className="text-left border border-gray-700">
              <th>Nomor</th>
              <th>Pernyataan</th>
              {skala.map((val, idx) => {
                return <th key={idx}>{val.keterangan}</th>;
              })}
            </tr>
            {data.map((val2, idx2) => {
              return (
                <tr className="border border-gray-700">
                  <td>{val2.nomor}</td>
                  <td>{val2.pernyataan}</td>
                  {skala.map((val3, idx3) => {
                    return (
                      <td key={idx3}>
                        <div className="flex items-center flex-row">
                          <input
                            type="radio"
                            checked={
                              answer[parseInt(val2.nomor) - 1] === val3.key
                            }
                            value={val3.key}
                            id={`${idx3}-${val2.nomor}-skala`}
                            name={`${val2.nomor}--skala`}
                            onChange={() =>
                              changeVal({
                                idx: parseInt(val2.nomor - 1),
                                val: val3.key,
                              })
                            }
                          />
                          <label for={`${idx3}-${val2.nomor}-skala`}>
                            {val3.keterangan}
                          </label>
                        </div>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </table>
        ) : null}
        {
          renderButton()
        }
      </div>
    );
  }

  function view2(params) {
    return (
      <div className="flex flex-col w-100 p-4 h-full">
        {/* <p>Liklert tipe 3</p> */}
        <div className="flex flex-col h-full">
          <div className="flex flex-row gap-4 overflow-x-scroll">
            {data.map((val, idx) => {
              return (
                <div
                  key={idx}
                  className={tab === idx ? "border-b-2 border-gray-700" : ""}
                >
                  <p>{val.nama_bab}</p>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col flex-1 overflow-y-scroll">
            {typeof fire === "boolean" ? (
              <table className="mb-4 mt-4 w-full border border-gray-700">
                <tr className="text-left border border-gray-700">
                  <th>Nomor</th>
                  <th>Pernyataan</th>
                  {skala.map((val, idx) => {
                    return <th key={idx}>{val.keterangan}</th>;
                  })}
                </tr>
                {data[tab].pernyataan.map((val2, idx2) => {
                  return (
                    <tr className="border border-gray-700">
                      <td>{val2.nomor}</td>
                      <td>{val2.pernyataan}</td>
                      {skala.map((val3, idx3) => {
                        return (
                          <td key={idx3}>
                            <div className="flex items-center flex-row">
                              <input
                                type="radio"
                                checked={
                                  answer[parseInt(val2.nomor) - 1] === val3.key
                                }
                                value={val3.key}
                                id={`${idx3}-${val2.nomor}-skala`}
                                name={`${val2.nomor}--skala`}
                                onChange={() =>
                                  changeVal({
                                    idx: parseInt(val2.nomor - 1),
                                    val: val3.key,
                                  })
                                }
                              />
                              <label for={`${idx3}-${val2.nomor}-skala`}>
                                {val3.keterangan}
                              </label>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </table>
            ) : null}
          </div>

          {renderButton()}
        </div>
      </div>
    );
  }

  function view3(params) {
    return (
      <div className="flex flex-col w-100 p-4 h-full">
        {/* <p>Liklert tipe 3</p> */}
        <div className="flex flex-col h-full">
          <div className="flex flex-row gap-4 overflow-x-scroll">
            {data.map((val, idx) => {
              return (
                <div
                  key={idx}
                  className={tab === idx ? "border-b-2 border-gray-700" : ""}
                >
                  <p>{val.nama_bab}</p>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col flex-1 overflow-y-scroll">
            {typeof fire === "boolean"
              ? data[tab].sub_bab.map((val, idx) => {
                  return (
                    <div key={idx} className="my-2 border-b">
                      <p className="my-4 text-lg font-bold">
                        {val.nama_sub_bab}
                      </p>
                      <table className="mb-4 w-full border border-gray-700">
                        <tr className="text-left border border-gray-700">
                          <th>Nomor</th>
                          <th>Pernyataan</th>
                          {skala.map((val, idx) => {
                            return <th key={idx}>{val.keterangan}</th>;
                          })}
                        </tr>
                        {val.pernyataan.map((val2, idx2) => {
                          return (
                            <tr className="border border-gray-700">
                              <td>{val2.nomor}</td>
                              <td>{val2.pernyataan}</td>
                              {skala.map((val3, idx3) => {
                                return (
                                  <td key={idx3}>
                                    <div className="flex items-center flex-row">
                                      <input
                                        type="radio"
                                        checked={
                                          answer[parseInt(val2.nomor) - 1] ===
                                          val3.key
                                        }
                                        value={val3.key}
                                        id={`${idx3}-${val2.nomor}-skala`}
                                        name={`${val2.nomor}--skala`}
                                        onChange={() =>
                                          changeVal({
                                            idx: parseInt(val2.nomor - 1),
                                            val: val3.key,
                                          })
                                        }
                                      />
                                      <label
                                        for={`${idx3}-${val2.nomor}-skala`}
                                      >
                                        {val3.key}
                                      </label>
                                    </div>
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })}
                      </table>
                    </div>
                  );
                })
              : null}
          </div>

          {renderButton()}
        </div>
      </div>
    );
  }

  function view(params) {
    if (tipe === 1) {
      return view1();
    } else if (tipe === 2) {
      return view2();
    } else if (tipe === 3) {
      return view3();
    } else {
      return null;
    }
  }

  function konfirmasiScoin(){
    let body = {responden_id: responden_id, kuesioner_id: kuesioner_id}
    
      axiosAPI
        .post(API + "scoin/konfirmasi", body)
        .then((res) => {
            save(res.data.message);
        })
        .catch((xhr) => {
          console.log(xhr)
        });

  }

  function save(params) {
    let body = {
      jawaban: answer,
    };
    setloadingSubmit(1);
    axiosAPI
      .post(API + "kuesioner/" + idKuesioner + "/kirim-jawaban", body)
      .then((res) => {
        if (res.data.status === "success") {
          swal.fire('Berhasil', params + ', ' + res.data.message, 'success')
          setloadingSubmit(2);
          window.location.replace("/partisipasi");
        } else {
          swal.fire('Gagal', params + ', ' + res.data.message, 'error')
          setloadingSubmit(2);
        }
      })
      .catch((err) => {
        setloadingSubmit(3);
      });
  }

  function renderSave(params) {
    let pesan = null;
    let buttonSubmit = null;
    if (loadingSubmit === 0) {
      pesan = <p>Submit jawaban anda?</p>;
      buttonSubmit = (
        <button
          onClick={() => konfirmasiScoin()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Submit
        </button>
      );
    } else if (loadingSubmit === 1) {
      pesan = <p>Loading</p>;
      buttonSubmit = (
        <button className="px-4 py-2 rounded-lg bg-gray-20">Loading</button>
      );
    } else if (loadingSubmit === 2) {
      pesan = <p>Berhasil</p>;
      buttonSubmit = (
        <button
          onClick={() => {
            window.history.back();
          }}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Oke
        </button>
      );
    } else {
      pesan = <p>Gagal submit</p>;
      buttonSubmit = (
        <button
          onClick={() => save()}
          className="px-4 py-2 rounded-lg bg-blue-500 text-white"
        >
          Ulangi
        </button>
      );
    }

    return (
      <div className="flex flex-col px-4 py-4">
        {pesan}
        <div className="flex flex-row gap-2 my-4">
          {buttonSubmit}
          <button
            onClick={() => setmodalSave(false)}
            className="px-4 py-2 rounded-lg bg-gray-200"
          >
            Batal
          </button>
        </div>
      </div>
    );
  }
  return (
    <>
      <ToastContainer />
      <SMModal
        title="Submit"
        show={modalSave}
        onClose={() => setmodalSave(!modalSave)}
      >
        {renderSave()}
      </SMModal>
      {view()}
    </>
  );
}
